package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.CSSColorValue

@Composable
fun Eyebrow(
    text: String,
    @Suppress("UNUSED_PARAMETER") accent: CSSColorValue = Palette.accent,
    @Suppress("UNUSED_PARAMETER") withDot: Boolean = false,
    modifier: Modifier = Modifier,
) {
    SpanText(
        text = text,
        modifier = Modifier
            .fontSize(Typography.bodySmall.size)
            .fontWeight(Typography.h4.weight)
            .color(Palette.textSecondary)
            .then(modifier),
    )
}
